import { getWellChoice } from 'helpers/WellHelper';
import { ObjectKeys } from 'helpers/ts-helpers';
import { useFetchAllCategorizedWells } from 'hooks/useFetchAllCategorizedWells';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useGetWellOptions = () => {
  const intl = useIntl();
  const {
    categorizedWells: { favouriteWells, activeSensorWells, activeWellviewWells, nonActiveWells },
  } = useFetchAllCategorizedWells(true);

  return useMemo(() => {
    const nonActiveWellsFlagged = nonActiveWells.map(nonActiveWell => ({
      ...nonActiveWell,
      isActive: false,
    }));
    const categorizedWells = {
      favouriteWells,
      activeSensorWells,
      activeWellviewWells,
      nonActiveWells: nonActiveWellsFlagged,
    };

    return ObjectKeys(categorizedWells).map(category => ({
      label: intl.formatMessage({ id: `well-select.categories.${category}` }),
      options: categorizedWells[category].map(getWellChoice),
    }));
  }, [activeSensorWells, activeWellviewWells, favouriteWells, nonActiveWells, intl]);
};
